<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/O0TGzM/tc-custom/9781526785916.jpg?1705259593565" alt="This image is the cover for the book English Rebels and Revolutionaries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">English Rebels and Revolutionaries
      </h1>
      <p class="bookDescription body article font2">
        <p>Throughout history brave Englishmen and women have never been afraid to rise up against their unjust rulers and demand their rights. Barely a century has gone by without England being witness to a major uprising against the government of the day, often resulting in a fundamental change to the constitution. This book is a collection of biographies, written by experts in their field, of the lives and deeds of famous English freedom fighters, rebels, and democrats who have had a major impact on history. Featured chapters include the history of Wat Tyler’s Rebellion, when an army of 50,000 people marched to London in 1381 to demand an end to serfdom and the hated poll tax. Alongside Wat Tyler in this pantheon of English revolutionaries is Jack Cade who in 1450 led an angry mob to London to protest against government corruption. There are three chapters on various aspects of the English Civil War, during which the English executed their king. Other rebel heroes featured include Thomas Paine, the great intellectual of the American and French Revolutions; Mary Wollstonecraft, author of The Rights of Woman; Henry Hunt, who, as well as the Chartists after him, campaigned for universal suffrage; William Morris, the visionary designer and socialist thinker; and finally the Suffragettes and Suffragists who fought for women’s voting rights.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stephen Basdeo
      </h2>
      
      <p class="authorDescription body article">Dr Stephen Basdeo is Assistant Professor of History at Richmond University (RIASA Leeds). His research interests include Georgian and Victorian medievalism, as well as the history of crime. He has published widely in these areas for both an academic and non-academic audience, and regularly blogs about his research on his website (www.gesteofrobinhood.com). He has published two other works with Pen and Sword: The Life and Legend of a Rebel Leader: Wat Tyler (2018) and The Lives and Exploits of the Most Noted Highwaymen, Rogues, and Murderers (2018).</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword History
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?939bb98a